import React from 'react';
import Heading from '../../controls/Heading';
import Form from '../Form';
import Video from '../Video';
interface VideoComponentProps {
  videoSrcURL: string;
  videoTitle: string;
  agent_email: string;
  agentName: string;
}
function VideoComponent({ videoSrcURL, videoTitle, agent_email, agentName }: VideoComponentProps) {
  const inputString = videoTitle;
  let Episode = '';
  const regex = /Episode (\d+)/;
  const match = regex.exec(inputString);

  if (match) {
    const episodeNumber = match[1];
    Episode = episodeNumber;
  } else {
    console.log('No match found');
  }
  return (
    <div className="mx-auto my-12 max-w-7xl px-5 md:px-1" id="video">
      <Heading text={<>Reaching Out and Tuning In</>} className="py-5 text-center" />
      <div
        className={`mb-8 flex flex-col flex-wrap items-center gap-9 md:px-7 lg:mt-20 xl:grid xl:grid-cols-2 xl:flex-row xl:items-center xl:gap-11`}
      >
        <div>
          <Form agent_email={agent_email} />
        </div>
        {videoSrcURL && (
          <div className="flex flex-col items-start justify-start lg:items-center lg:justify-center">
            <div className="rounded-md bg-[#FFFFFF] px-5 py-7 shadow-[#B0B7C3] drop-shadow-sm md:px-9 md:py-7">
              <div className="hidden items-center justify-between lg:flex lg:py-2">
                <span>{agentName ? agentName : ''}</span>
                {Episode ? <span className="text-brand">Episode {Episode ?? ''}</span> : ''}
              </div>
              <div className="hidden py-1 lg:block">
                {videoTitle ? videoTitle + '-' + agentName : ''}
              </div>
              <Video
                videoSrcURL={videoSrcURL}
                videoTitle={videoTitle}
                className={
                  'h-[424px] w-full overflow-hidden rounded-lg bg-gray-500 md:m-4 md:h-[calc((75vw-30px)*9/16)] md:w-[75vw] lg:m-0 lg:w-[516px] xl:h-[424px] '
                }
              />
            </div>
            <div className="flex flex-col items-start justify-start gap-2 py-2 pt-5 lg:hidden">
              <span>{agentName ? agentName : ''}</span>
              {Episode ? <span className="text-brand">Episode {Episode ?? ''}</span> : ''}
            </div>
            <div className="py-1 lg:hidden">{videoTitle ? videoTitle + '-' + agentName : ''}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VideoComponent;
